module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100 pa3"
  }, [_c('div', {
    staticClass: "tc pl-title mb3"
  }, [_vm._v("The RoundTable Prompt")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Got it!\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mh3 pa3 flex-grow"
  }, [_c('div', {
    staticClass: "flex justify-center mb2"
  }, [_c('img', {
    staticClass: "ma3",
    attrs: {
      "src": "/static/online_roundtable_icons/browse_universe_icon.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ma3",
    attrs: {
      "src": "/static/online_roundtable_icons/from_scratch.svg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pl-subheading tl"
  }, [_vm._v("\n      Browse the Parlay Universe to discover a discussion prompt for your\n      students. You can edit the content to suit your needs, or create a brand\n      new topic from scratch.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-49aef4b4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineWalkthrough/pages/onlineWalkthroughPrompt.vue
// module id = 1322
// module chunks = 61